import React, { CSSProperties } from "react";
import classNames from "classnames";
import { ripple } from "../ripple";

interface SwitchProps {
    id?: string;
    className?: string;
    label?: string;
    labelClassName?: string;
    labelStyle?: CSSProperties | undefined;
    color?: string;
    size?: "" | "sm";
    disabled?: boolean;
    model?: boolean;
    labelPlacement?: "start" | "end";
    onChange?: (e) => void;
    onFocus?: (e) => void;
    onBlur?: (e) => void;
    onMouseLeave?: (e) => void;
    onMouseDown?: (e) => void;
    setModel?: (model: boolean) => void;
    [x: string]: any;
}

export const Switch = ({
    id,
    className,
    label,
    labelClassName = "",
    labelStyle,
    color,
    size,
    disabled,
    model,
    edge,
    compact,
    labelPlacement,
    onChange,
    onFocus,
    onBlur,
    onMouseLeave,
    onMouseDown,
    setModel,
    ...props
}: SwitchProps) => {
    if (!color) color = "primary";
    if (!labelPlacement) labelPlacement = "end";
    const cn = classNames(className, "switch", {
        "switch-primary": color === "primary",
        "switch-secondary": color === "secondary",
        "switch-default": color === "default",
        "switch-sm": size === "sm",
        "edge-start": edge === "start",
        "edge-end": edge === "end",
        "bd-compact": compact,
        disabled: disabled,
    });

    const getThumb = (switchElem) => switchElem.getElementsByClassName("switch-thumb")[0];

    let inputProps;
    inputProps = { checked: model ?? false, onChange: onChangeHandler };
    if (disabled) inputProps = { ...inputProps, disabled };

    inputProps = {
        ...inputProps,
        onFocus: (e) => {
            const thumbElem = getThumb(e.currentTarget.parentNode);
            ripple.focus(thumbElem);
            if (onFocus) onFocus(e);
        },

        onBlur: (e) => {
            const thumbElem = getThumb(e.currentTarget.parentNode);
            ripple.blur(thumbElem);
            if (onBlur) onBlur(e);
        },

        //onFocus: focusBorderRipple.show,
        //onBlur: focusBorderRipple.hide,
    };

    const rippleProps = {
        onMouseLeave: (e) => {
            const thumbElem = getThumb(e.currentTarget);
            ripple.removeFocus(thumbElem);
            if (onMouseLeave) onMouseLeave(e);
        },
        onMouseDown: (e) => {
            const thumbElem = getThumb(e.currentTarget);
            ripple.pulse(thumbElem, 0, 0);
            if (onMouseDown) onMouseDown(e);
        },

        //onMouseMove: focusBorderRipple.hide,
        //onMouseUp: focusBorderRipple.hide,
    };

    function onChangeHandler(e) {
        if (setModel) setModel(e.target.checked);
        if (onChange) onChange(e);
    }

    function renderSwitch() {
        return (
            <span className={cn} {...props} {...rippleProps}>
                <input id={id} type="checkbox" {...inputProps} />
                <span className="switch-track"></span>
                <span className="switch-thumb"></span>
            </span>
        );
    }

    return (
        <label className={classNames("switch-label", labelClassName, { "text-secondary-text": disabled })} style={labelStyle}>
            {labelPlacement === "start" && label}
            {renderSwitch()}
            {labelPlacement === "end" && label}
        </label>
    );
};
